import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterToolbar = ({ onSearch, onDateFilter, onExport, onImport, selectedCount }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showAdvanced, setShowAdvanced] = useState(false);

  const savedFilters = [
    { value: 'all', label: 'All Properties' },
    { value: 'vacant', label: 'Vacant Properties' },
    { value: 'expiring-soon', label: 'Tenancies Expiring Soon' },
    { value: 'high-value', label: 'High Value Properties (£2000+)' },
    { value: 'maintenance-due', label: 'Maintenance Due' }
  ];

  const handleSearch = (value) => {
    setSearchQuery(value);
    onSearch(value);
  };

  const handleExport = () => {
    console.log('Exporting properties...');
    onExport();
  };

  const handleImport = () => {
    console.log('Opening import modal...');
    onImport();
  };

  return (
    <div className="space-y-4 mb-4">
      <div className="flex flex-col lg:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by Property ID, address, postcode..."
            value={searchQuery}
            onChange={(e) => handleSearch(e?.target?.value)}
          />
        </div>
        
        <div className="flex gap-2">
          <Button
            variant="outline"
            iconName="Filter"
            iconPosition="left"
            onClick={() => setShowAdvanced(!showAdvanced)}
          >
            Advanced
          </Button>
          
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={handleExport}
          >
            Export
          </Button>
          
          <Button
            variant="outline"
            iconName="Upload"
            iconPosition="left"
            onClick={handleImport}
          >
            Import
          </Button>
        </div>
      </div>
      {showAdvanced && (
        <div className="p-4 rounded-lg bg-surface border border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Select
              label="Saved Filters"
              options={savedFilters}
              placeholder="Select preset"
            />
            
            <Input
              label="Tenancy Start From"
              type="date"
            />
            
            <Input
              label="Tenancy Start To"
              type="date"
            />
            
            <Input
              label="Min Monthly Rent (£)"
              type="number"
              placeholder="0"
            />
          </div>
          
          <div className="flex gap-2 mt-4">
            <Button variant="default" size="sm" iconName="Search" iconPosition="left">
              Apply Filters
            </Button>
            <Button variant="outline" size="sm" onClick={() => setShowAdvanced(false)}>
              Clear
            </Button>
          </div>
        </div>
      )}
      {selectedCount > 0 && (
        <div className="flex items-center justify-between p-4 rounded-lg bg-accent/10 border border-accent">
          <div className="flex items-center gap-3">
            <Icon name="CheckSquare" size={20} color="var(--color-accent)" />
            <span className="text-sm font-medium text-foreground font-caption">
              {selectedCount} {selectedCount === 1 ? 'property' : 'properties'} selected
            </span>
          </div>
          
          <div className="flex gap-2">
            <Button variant="outline" size="sm" iconName="Edit" iconPosition="left">
              Bulk Edit
            </Button>
            <Button variant="outline" size="sm" iconName="UserCheck" iconPosition="left">
              Reassign Landlord
            </Button>
            <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
              Export Selected
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterToolbar;